import slice from "./slice";

export const { resetState, setReadOnlyTakeOff, setTakeOffLocation, setDestinationLocation } = slice.actions;